// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".seperator {\n  height: 100%;\n  width: 1px;\n  background: #DBE2E6;\n  margin-left: auto;\n}\n", ""]);
// Exports
module.exports = exports;
